// Unified Search Results page — chooses the correct module schema + card renderer
// based on the URL `:type` param. Replaces SearchResults + all secondary search pages.
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ResultsPageLayout from './search/ResultsPageLayout';
import {
  FlightCard, HotelCard, BusCard, TrainCard, CabCard,
  VillaCard, PackageCard, TourCard, VisaCard, CruiseCard, ForexCard, InsuranceCard,
} from './search/resultCards';

// Map URL slug → schema key + card renderer
const ROUTE_MAP = {
  flights:   { module: 'flights',   render: (item) => <FlightCard key={item.fare_id} flight={item} /> },
  hotels:    { module: 'hotels',    render: (item) => <HotelCard  key={item.id}      hotel={item} /> },
  bus:       { module: 'buses',     render: (item) => <BusCard    key={item.id}      bus={item} /> },
  buses:     { module: 'buses',     render: (item) => <BusCard    key={item.id}      bus={item} /> },
  train:     { module: 'trains',    render: (item) => <TrainCard  key={item.id}      train={item} /> },
  trains:    { module: 'trains',    render: (item) => <TrainCard  key={item.id}      train={item} /> },
  cab:       { module: 'cabs',      render: (item) => <CabCard    key={item.id}      cab={item} /> },
  cabs:      { module: 'cabs',      render: (item) => <CabCard    key={item.id}      cab={item} /> },
  villas:    { module: 'villas',    render: (item) => <VillaCard  key={item.id}      item={item} /> },
  packages:  { module: 'packages',  render: (item) => <PackageCard key={item.id}     item={item} /> },
  tours:     { module: 'tours',     render: (item) => <TourCard   key={item.id}      item={item} /> },
  visa:      { module: 'visa',      render: (item) => <VisaCard   key={item.id}      item={item} /> },
  cruise:    { module: 'cruise',    render: (item) => <CruiseCard key={item.id}      item={item} /> },
  forex:     { module: 'forex',     render: (item) => <ForexCard  key={item.id}      item={item} /> },
  insurance: { module: 'insurance', render: (item) => <InsuranceCard key={item.id}   item={item} /> },
};

const UnifiedSearchPage = () => {
  const { type } = useParams();
  const entry = ROUTE_MAP[type];
  if (!entry) return <Navigate to="/" replace />;
  return <ResultsPageLayout moduleKey={entry.module} renderCard={entry.render} />;
};

export default UnifiedSearchPage;
